var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-title"},[_c('strong',{staticClass:"slidetop",attrs:{"data-scroll":"","data-scroll-call":"animateMove"}},[_vm._v(_vm._s(_vm.commonTitle.title))]),_c('small',{staticClass:"slidetop detay1",attrs:{"data-scroll":"","data-scroll-call":"animateMove"}},[_vm._v(_vm._s(_vm.commonTitle.sen))])])
}
var staticRenderFns = []

export { render, staticRenderFns }